module.exports = __webpack_public_path__ + "static/img/PF.07e39cbc.png";